import { ComponentProps } from 'react';
import Menu from 'antd/es/menu';
import clsx from 'clsx';

interface OpMenuProps extends Omit<ComponentProps<typeof Menu>, 'data-testid'> {
  testId?: string;
}

/**
 * OpMenu is a wrapper around Ant Design's Menu component.
 * It displays a list of navigation or action items in a vertical or horizontal layout.
 * 
 * Use this component for navigation menus, dropdown menus, or any list of selectable items.
 * Supports nested sub-menus, icons, and various selection modes.
 * 
 * @example
 * <OpMenu
 *   mode="vertical"
 *   selectedKeys={[selectedKey]}
 *   items={menuItems}
 *   onClick={handleMenuClick}
 * />
 * 
 */
export const OpMenu = ({
  className,
  testId = 'op-menu',
  ...menuProps
}: OpMenuProps) => {
  return (
    <Menu
      className={clsx('op-menu', className)}
      {...menuProps}
      data-testid={testId}
    />
  );
};
